import React, { memo } from "react";

// widget
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

//dls
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";

//helpers
import { isEmpty } from "@swiggy-private/js-utils";

export interface CroutonTextProps {
    title: string | React.ReactNode;
    subText?: string | React.ReactNode;
    titleClassName?: string;
    subTextClassName?: string;
    textColor?: keyof IColors;
}

function CroutonTextContent({
    title,
    subText,
    titleClassName,
    subTextClassName,
    textColor,
}: CroutonTextProps): JSX.Element {
    if (isEmpty(subText)) {
        return <span className={titleClassName}>{title}</span>;
    }

    if (typeof title !== "string") {
        return <>{title}</>;
    }

    return (
        <span>
            <Text
                variant="V2.body2.neutral.medium"
                color={textColor ?? "text_inverse_Highest_Emphasis"}
                className={titleClassName}
            >
                {title}
            </Text>
            <Text variant="V2.body2.neutral.regular" color="text_inverse_High_Emphasis" className={subTextClassName}>
                {subText}
            </Text>
        </span>
    );
}

export default memo(CroutonTextContent);
